import { useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import GlobalStyle from 'packages/kakapo-ui-kit/components/GlobalStyle';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import treams from 'packages/kakapo-ui-kit/themes/treams';
import { replaceColorsInTheme } from 'packages/kakapo-ui-application/layouts/BareLayout';

import { CertificateA4 } from '../components/certificates/CertificatePreviewContainer';

const Container = styled.div`
	flex-direction: column;
	justify-content: stretch;
	font-family: '${(props) => props.theme.fontFamilies.paragraph}';
`;

export default function LearningCertificateRender({ certificateID }: { certificateID: string }) {
	const { localize } = useLocalize();

	const workspace = useWorkspace();
	const { loading: loadingTheme, data: themeData } = graphql.useWorkspaceThemeQuery({
		variables: { id: workspace.id },
	});

	const theme = themeData
		? replaceColorsInTheme(themeData.workspace.theme as graphql.WorkspaceTheme)
		: treams;

	useEffect(() => {
		document.body.style.width = '297mm';
		document.body.style.height = '210mm';
		document.body.style.overflow = 'hidden';
	}, []);

	const { data, loading } = graphql.useLearningAwardedCertificateQuery({
		variables: {
			id: certificateID,
		},
	});

	if (loading || loadingTheme || !data) {
		return null;
	}

	const certificate = data?.learningAwardedCertificate as graphql.LearningAwardedCertificate;

	const { user, template, event } = certificate;

	return (
		<Container>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				<div data-rendered="true" />
				<CertificateA4
					accentColor={template.accentColor ?? undefined}
					attendeeName={`${user.firstName} ${user.lastName}`}
					eventDate={event.startDate}
					eventDescription={localize(certificate.description).text}
					eventTitle={localize(event.title).text}
					logo={template.logo?.source.url}
					signature={template.signature?.source.url}
					signerName={template.signerName ?? undefined}
					signerTitle={template.signerTitle ?? undefined}
					scale={1}
					showBounds={false}
				/>
			</ThemeProvider>
		</Container>
	);
}
